import { cn } from "@/lib/utils";

interface BrandLogoProps {
  compact?: boolean;
  iconOnly?: boolean;
  className?: string;
}

/** Simbolo da marca: os dois elos de sempre, em tinta, sobre o lima marca-texto. */
export function BrandMark({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      aria-hidden="true"
    >
      <rect width="128" height="128" rx="30" fill="hsl(var(--signal))" />
      <g stroke="hsl(var(--signal-foreground))" strokeWidth="13" strokeLinecap="round" fill="none">
        <rect x="26" y="40" width="62" height="34" rx="17" transform="rotate(-45 57 57)" />
        <rect x="40" y="54" width="62" height="34" rx="17" transform="rotate(-45 71 71)" />
      </g>
    </svg>
  );
}

export function BrandLogo({ compact = false, iconOnly = false, className }: BrandLogoProps): JSX.Element {
  return (
    <div className={cn("flex min-w-0 items-center gap-2.5 select-none", className)} aria-label="LucraLink">
      <BrandMark className={compact ? "h-7 w-7" : "h-8 w-8"} />

      {!iconOnly && (
        <span
          className={cn(
            "font-sans font-bold tracking-[-0.03em] text-foreground flex items-center",
            compact ? "text-base" : "text-lg",
          )}
        >
          Lucra<span className="text-signal">Link</span>
        </span>
      )}
    </div>
  );
}
